import { render, staticRenderFns } from "./SwitchCompany.vue?vue&type=template&id=9f719e36&scoped=true"
import script from "./SwitchCompany.vue?vue&type=script&lang=js"
export * from "./SwitchCompany.vue?vue&type=script&lang=js"
import style0 from "./SwitchCompany.vue?vue&type=style&index=0&id=9f719e36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f719e36",
  null
  
)

export default component.exports